import React from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGE = "/images/hero_section_pic.jpeg";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    if (window.location.pathname === '/') {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="bg-gradient-to-br from-secondary to-white section-padding">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <div className="space-y-6 animate-slide-up">
            <h1 className="text-5xl md:text-6xl font-bold text-primary leading-tight">
              PÉTALES <span className="text-accent">DE DOUCEUR</span>
            </h1>
            
            <p className="text-2xl text-accent font-light">
              L'art du chocolat raffiné, créateur de moments précieux
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Chaque création est une invitation au voyage sensoriel, élaborée avec 
              passion et expertise artisanale.
            </p>
            
            <div className="flex flex-wrap gap-4 pt-4">
              <button 
                onClick={() => scrollToSection('products')}
                className="btn-primary"
              >
                <i className="fas fa-gift"></i>
                Découvrir nos produits
              </button>
              
              <Link to="/contact" className="btn-secondary">
                <i className="fas fa-calendar-alt"></i>
                Nous contacter
              </Link>
            </div>
          </div>
          
          {/* Right Image */}
          <div className="relative">
            <div className="bg-primary/10 rounded-3xl p-8">
              <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                
                <img 
                  src={HERO_IMAGE}
                  alt="Création Pétales de Douceur"
                  className="w-full aspect-square object-cover rounded-2xl"
                />

              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-accent/10 rounded-full hidden md:block"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-primary/10 rounded-full hidden md:block"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;